import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Sparkles, Crown, Heart, ArrowRight, Star, Dumbbell } from 'lucide-react';
import { Button } from '../components/ui/button';

const WompiSuccessPreview = () => {
  const navigate = useNavigate();
  const userName = 'Carolina';
  const reference = 'plan_premium_abc12345';
  
  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center p-4 relative overflow-hidden">
      {/* Efectos de fondo celebración */}
      <div className="absolute inset-0 bg-gradient-to-br from-pink-500/20 via-transparent to-purple-500/20" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-gradient-to-b from-pink-500/10 to-transparent" />
      
      {/* Estrellas flotantes */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {[...Array(20)].map((_, i) => (
          <Sparkles 
            key={i} 
            className="absolute text-pink-400/30 animate-pulse"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              width: `${Math.random() * 20 + 10}px`,
              height: `${Math.random() * 20 + 10}px`,
              animationDelay: `${Math.random() * 2}s`
            }}
          />
        ))}
      </div>
      
      <div className="relative z-10 max-w-lg w-full">
        {/* Card principal */}
        <div className="bg-zinc-900/90 backdrop-blur-xl border border-pink-500/30 rounded-3xl p-8 text-center shadow-2xl shadow-pink-500/20">
          {/* Icono de éxito con animación */}
          <div className="relative w-24 h-24 mx-auto mb-6">
            <div className="absolute inset-0 bg-gradient-to-br from-pink-500 to-purple-500 rounded-full animate-pulse" />
            <div className="absolute inset-1 bg-zinc-900 rounded-full flex items-center justify-center">
              <CheckCircle className="w-12 h-12 text-pink-500" />
            </div>
            {/* Corona */}
            <Crown className="absolute -top-3 left-1/2 -translate-x-1/2 w-8 h-8 text-amber-400 animate-bounce" />
          </div>
          
          {/* Mensaje de bienvenida */}
          <div className="space-y-2 mb-6">
            <p className="text-pink-400 text-sm font-medium uppercase tracking-wider">¡Felicidades!</p>
            <h1 className="text-3xl md:text-4xl font-bold text-white">
              ¡Bienvenida a
            </h1>
            <h2 className="text-2xl md:text-3xl font-bold bg-gradient-to-r from-pink-400 via-pink-500 to-purple-500 text-transparent bg-clip-text">
              Booty & Legs Academy!
            </h2>
            <p className="text-xl text-zinc-300 mt-2">
              <Heart className="inline w-5 h-5 text-pink-500 mr-1" />
              {userName}
            </p>
          </div>
          
          {/* Mensaje motivacional */}
          <div className="bg-gradient-to-r from-pink-500/10 to-purple-500/10 border border-pink-500/20 rounded-2xl p-4 mb-6">
            <p className="text-zinc-300 text-sm leading-relaxed">
              Tu transformación comienza ahora. Tienes acceso completo a tu contenido exclusivo.
              <br/>
              <span className="text-pink-400 font-medium">¡Es hora de brillar!</span> ✨
            </p>
          </div>
          
          {/* Lo que incluye */}
          <div className="grid grid-cols-3 gap-3 mb-6">
            <div className="bg-zinc-800/50 rounded-xl p-3">
              <Dumbbell className="w-6 h-6 text-pink-400 mx-auto mb-1" />
              <p className="text-xs text-zinc-400">Rutinas</p>
            </div>
            <div className="bg-zinc-800/50 rounded-xl p-3">
              <Star className="w-6 h-6 text-amber-400 mx-auto mb-1" />
              <p className="text-xs text-zinc-400">Nutrición</p>
            </div>
            <div className="bg-zinc-800/50 rounded-xl p-3">
              <Heart className="w-6 h-6 text-red-400 mx-auto mb-1" />
              <p className="text-xs text-zinc-400">Mindset</p>
            </div>
          </div>
          
          <p className="text-xs text-zinc-500 mb-6">Referencia: {reference}</p>
          
          {/* Botón principal */}
          <Button 
            onClick={() => navigate('/dashboard')}
            className="w-full bg-gradient-to-r from-pink-500 to-purple-500 hover:from-pink-600 hover:to-purple-600 text-white rounded-xl py-4 text-lg font-semibold shadow-lg shadow-pink-500/30 transition-all hover:scale-[1.02] group"
          >
            Comenzar Mi Transformación
            <ArrowRight className="inline ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WompiSuccessPreview;
